<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="modal-container" @click.stop>

                            <div class="flex-header" style="justify-content: space-between;">
                                <div>
                                    <h2 class="transporter-title">Edit</h2>
                                </div>
                                <div>
                                    <div class="modal-close" @click="$emit('closeModal')">
                                        <i class="fal fa-times fa-2x"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body">

                                <div style="max-height:600px; max-width: 650px;">
                                    <div class="row mt-3 f-25">
                                        <div class="col-4">
                                            <label>NO SJ</label>
                                        </div>

                                        <div class="col-8">
                                            <div v-if="Array.isArray(result)" class="scrollable-list">
                                                <p v-for="(item, index) in result">
                                                    {{ `${index + 1}. ` }} {{ item.no_sl }}
                                                </p>
                                            </div>
                                            <div v-else>
                                                <p>{{ result.no_sl }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3 f-25">
                                        <div class="col-4">
                                            <label>NO TO</label>
                                        </div>

                                        <div class="col-8">
                                            <div v-if="Array.isArray(result)" class="scrollable-list">
                                                <p v-for="(item, index) in result">
                                                    {{ `${index + 1}. ` }} {{ item.no_referensi }}
                                                </p>
                                            </div>
                                            <div v-else>
                                                <p>{{ result.no_referensi }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-3 f-25">
                                        <div class="col-4">
                                            <label>Nopol</label>
                                        </div>
                                        <div class="col-8">
                                            <MultiSelect v-model="form.nopol" :options="listNopol" :multiple="false"
                                                :maxHeight="100" selectLabel="" deselectLabel="" selectedLabel=""
                                                class="transporter-multiselect no-caret" placeholder="Select NOPOL" />
                                        </div>
                                    </div>

                                    <div class="row mt-3 f-25">
                                        <div class="col-4">
                                            <label>Tanggal SJ</label>
                                        </div>
                                        <div class="col-8">
                                            <flat-pickr :config="rangePickr" placeholder="Select Date"
                                                v-model="form.to_tgl_sl"
                                                style="font: normal normal normal 12px/18px Poppins;"></flat-pickr>
                                        </div>
                                    </div>

                                    <div class="row mt-5 f-25">
                                        <div class="col-6">
                                            <button class="w-100 btn border rounded" @click="$emit('closeModal')" style="
                                                background-color: white;
                                                color: #1B698E;
                                                border: 1px solid #1B698E!important;">
                                                Batal
                                            </button>
                                        </div>
                                        <div class="col-6">
                                            <button class="w-100 btn rounded" @click="processData" style="
                                                background-color: #1B698E;
                                                color: white;">
                                                Edit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    props: ['data'],
    created() {
        if (this.data) {
            this.result = Array.isArray(this.data) ? this.data : JSON.parse(this.data);
            this.mountedListNopol()
        }
    },
    data() {
        return {
            rangePickr: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d-m-Y",
                altInputClass: 'form-control input mpm--transporter--flatpickr'
            },
            dataReady: false,
            mobile: this.isMobile(),
            result: '',
            form: {
                nopol: '',
                to_tgl_sl: '',
                no_referensi: '',
                from_tgl_sl: '',
                no_sl: ''
            },
            listNopol: [],
            collapsedPass: true
        }
    },
    methods: {
        processData() {
            if (Array.isArray(this.result)) {

                let htmlContent = '';

            htmlContent = `<div class="custom-swal-content"><p>Anda akan melakukan transfer</p>`;

            let allNoReferensi = this.result.map(val => val.no_referensi);
            let allNoSj = this.result.map(val => val.no_sl);

            allNoSj.forEach((sj, index) => {
                    if (index === 0) {
                        htmlContent += `<span class="data-row">No SJ : <strong>${index + 1}. ${sj}</strong></span>`;
                    } else {
                        htmlContent += `<span class="data-row" style="padding-left: 52px;"><strong>${index + 1}. ${sj}</strong></span>`;
                    }
                });

            allNoReferensi.forEach((to, index) => {
                    if (index === 0) {
                        htmlContent += `<span class="data-row">No TO : <strong>${index + 1}. ${to}</strong></span>`;
                    } else {
                        htmlContent += `<span class="data-row" style="padding-left: 55px;"><strong>${index + 1}. ${to}</strong></span>`;
                    }
                });

            htmlContent += `<span class="data-row">NOPOL : <strong>${this.form.nopol}</strong></span>`;
            htmlContent += `<span class="data-row">Tanggal SJ : <strong>${this.form.to_tgl_sl}</strong></span>`;

            htmlContent += '</div>';
            

                this.$swal.fire({
                    icon: 'warning',
                    title: 'Apakah Anda Yakin?',
                    html: htmlContent,
                    showCancelButton: true,
                    confirmButtonText: 'Transfer',
                    cancelButtonText: 'Batal',
                    customClass: {
                        popup: 'custom-swal-popup',
                        confirmButton: 'swal2-confirm',
                        cancelButton: 'swal2-cancel'
                    },
                    buttonsStyling: false,
                    reverseButtons: true,
                    focusConfirm: false
                }).then((result) => {
                        this.form.no_sl = allNoSj.join(',');
                        this.form.no_referensi = allNoReferensi.join(',');
                        this.form.from_tgl_sl = this.result.map(val => val.tgl_sl).join(',');
                    if (result.value) {
                        this.$http.put('/api/monitoring/update-transfer-to', this.form).then((resp) => {
                            this.$swal.fire({
                                title: 'Sukses!',
                                text: resp.data.message,
                                icon: 'success',
                            })
                            this.$emit('refreshTable');
                            this.$emit('closeModal');
                        }).catch((err) => {
                            this.$swal.fire({
                                title: "Error!",
                                icon: "error",
                                type: "error",
                                text: err.response.data.message
                            })
                        })
                    }
                })
                
            } else {
                this.$swal.fire({
                    icon: 'warning',
                title: 'Apakah Anda Yakin?',
                html: `
                    <div class="custom-swal-content">
                        <p>Anda akan melakukan transfer</p>
                        <span class="data-row">No SJ : <strong>${this.result.no_sl}</strong></span>
                        <span class="data-row">No TO : <strong>${this.result.no_referensi}</strong></span>
                        <span class="data-row">NOPOL : <strong>${this.form.nopol}</strong></span>
                        <span class="data-row">Tanggal SJ : <strong>${this.form.to_tgl_sl}</strong></span>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Transfer',
                cancelButtonText: 'Batal',
                confirmButtonColor: '#2c5282',
                cancelButtonColor: '#ffffff',
                customClass: {
                    popup: 'custom-swal-popup',
                    confirmButton: 'swal2-confirm',
                    cancelButton: 'swal2-cancel'
                },
                buttonsStyling: false,
                reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.form.no_sl = this.result.no_sl;
                        this.form.no_referensi = this.result.no_referensi;
                        this.form.from_tgl_sl = this.result.tgl_sl;

                        this.$http.put('/api/monitoring/update-transfer-to', this.form).then((resp) => {
                            this.$swal.fire({
                                title: 'Sukses!',
                                text: resp.data.message,
                                icon: 'success',
                            })
                            this.$emit('refreshTable');
                            this.$emit('closeModal');
                        }).catch((err) => {
                            this.$swal.fire({
                                title: "Error!",
                                icon: "error",
                                type: "error",
                                text: err.response.data.message
                            })
                        })
                    }
                })
            }
        },
        mountedListNopol() {
            this.$http.get('/api/master/nopol').then((resp) => {
                this.listNopol = resp.data.data.map(val => val.username);
            })
        },
    }
}
</script>

<style>
.custom-swal-popup {
    border-radius: 12px;
    padding: 30px;
}

.custom-swal-content {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    text-align: center;
}

.custom-swal-content p {
    margin-bottom: 20px;
    color: #333;
}

.custom-swal-content .data-row {
    color: #333;
    display: block;
    margin: 8px 0;
}

.custom-swal-content .data-row strong {
    font-weight: 600;
}

.swal2-actions {
    margin-top: 30px !important;
    gap: 10px;
}

.swal2-confirm {
    background-color: #2c5282 !important;
    color: white !important;
    padding: 10px 30px !important;
    border-radius: 6px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    border: none !important;
    box-shadow: none !important;
    min-width: 120px;
}

.swal2-confirm:hover {
    background-color: #2d3748 !important;
}

.swal2-cancel {
    background-color: transparent !important;
    color: #2c5282 !important;
    border: 1px solid #e2e8f0 !important;
    padding: 10px 30px !important;
    border-radius: 6px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    min-width: 120px;
}

.swal2-cancel:hover {
    background-color: #f7fafc !important;
    border-color: #cbd5e0 !important;
}
</style>

<style scoped>
.flex-header {
    display: flex;
}

.f-25 {
    font-size: 18px;
}

.wrap-text {
    word-wrap: break-word;
}

.modal-mask {
    position: fixed;
    z-index: 1020;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    margin: 0px auto;
    /* padding: 20px 30px; */
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    overflow: auto;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    padding: 25px 70px 40px;
}

.modal-default-button {
    float: right;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
    margin: 0
}

.modal-body .moduleLine {
    margin-bottom: 0vh;
}

.modal-body .moduleLine a {
    text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
    background-color: #E0E0E0;
    transition: background-color 0.7s ease;
    color: #212121;
    transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
    border: 1px solid #BDBDBD;
    border-radius: 20px;
    padding: 20px 0;
    color: black;
    margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
    font-size: 5vh;
}

h3.modalHeadline {
    margin: 0 0 20px 0;
    font-weight: bold;
    text-align: center;
}

/* MODAL ENDS */

/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
}

.input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
}

.input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
}

.input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
}

.input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
}

.input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
}

.label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
}

.radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-container input:checked~.checkmark {
    background-color: #e5e5e5;
}

.radio-container input:checked~.checkmark:after {
    display: block;
}

.radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
}

.checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding: 20px;
}

.input-group-icon {
    position: relative;
}

.input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
    font-size: 40px;
    color: #525252;
    /* margin-bottom: 40px; */
    text-align: center;
}

.transporter-title {
    font-family: 'Poppins';
    font-size: 20px;
    font-weight: medium;

    padding: 20px 25px;
    margin: 0;
}

.sub--title {
    color: red;
    margin-bottom: 40px;
    text-align: center;
}


.center {
    text-align: center;
}

.left {
    text-align: left;
}

.right {
    text-align: right;
}

.outerBox {
    padding: 0 20px;
}

.innerBox {
    padding: 0.8em 1.5em;
    border: 1px solid #EEEEEE;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #E0E0E0;
}

.paddingInnerInnerBox {
    padding: 10px 15px;
}

.outerBoxPass {
    padding: 20px;
}

.innerBoxPass {
    border: 1px solid #BDBDBD;
    border-radius: 5px;
    box-shadow: 10px 10px 20px #E0E0E0;
}

.innerBoxPass>.row:first-child {
    cursor: pointer;
}

.paddingInnerInnerBox p {
    margin: 0;
}

.subPartTitle {
    font-size: 110%;
    padding: 6px 12px;
    color: #757575;
}

.collapsed:hover {
    text-decoration: underline;
}

.collapseButton {
    color: black;
}

.modal-close {
    background-color: #F2F2F2;
    color: black;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border-top-right-radius: 8px;

    cursor: pointer;
    transition: background-color .3s ease;
}

.modal-close:hover {
    background-color: #E0E0E0;
}

.input--style-4:disabled {
    background: #cfcfcf;
}

.modal-body {
    max-height: 80vh;
}

.innerBox {
    padding: 0.8em 1.5em;
    border: 1px solid #EEEEEE;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #E0E0E0;
}

.hoverable:hover {
    cursor: pointer;
}

.input-with-unit {
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px 16px;
    background-color: #fff;
    width: 100%;
    max-width: 400px;
}

.input-with-unit input {
    border: none;
    outline: none;
    background: transparent;
    flex: 1;
    font-size: 16px;
    color: #333;
}

.input-with-unit .unit-label {
    color: #666;
    font-size: 16px;
    margin-left: 8px;
    white-space: nowrap;
}

.input-with-unit:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.scrollable-list {
    max-height: 80px;
    overflow-y: auto;
}

.scrollable-list p {
    margin: 2px 0;
}
</style>